import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import User from "../../APIController/User";
import Form from "../../Components/Form";
import Text from "../../Components/Text";
import TextInput from "../../Components/Form/TextInput";
import Button from "../../Components/Buttons/Button";
import Snackbar from "../../Components/Elements/Snackbar";

const SendMail = () => {
  const [email, setEmail] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const navigate = useNavigate();
  const { requestMail } = User();

  const handleSignIn = () => {
    navigate("/app/login");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = {
      email: email
    }
    await requestMail(body)
    navigate("/app/");
  };

  return (
    <>
      <Form onSubmitAction={handleSubmit} submitButtonText={"Mail anfordern"} size="w-full" background="bg-white" border="">
        <Text type="maintitle" classNames={"flex text-center justify-center"}>Passwort Resetten</Text>
        <TextInput placeholder={"E-Mail"} action={(e) => setEmail(e.target.value)} type={"email"}></TextInput>
      </Form>
      <div className="flex flex-row items-center p-2">
        <Text type="buttontext">Kein Account?</Text>
        <Button classNames="text-blue-500 hover:underline" buttonColor="transparent" borderStyle="" text={"Password wieder bekannt?"} onClickAction={() => handleSignIn()} />
      </div>
      <Snackbar message={snackbarMessage} onClose={() => setSnackbarMessage("")} />
    </>
  );
};

export default SendMail;
